/**
 * Form validation utilities for the application
 */

import { getTranslation } from './translate.js';

/**
 * Validates a dish form data object
 * @param {Object} formData - The form data to validate
 * @param {string} language - The current language
 * @returns {Object} An object containing validation errors, if any
 */
export const validateDishForm = (formData, language) => {
  const errors = {};

  // Required Fields Validation
  if (!formData.nameHy) {
    errors.nameHy = getTranslation('validation.nameRequired', language);
  }

  if (!formData.type) {
    errors.type = getTranslation('validation.typeRequired', language);
  }

  if (!formData.expirationDate) {
    errors.expirationDate = getTranslation('validation.expirationRequired', language);
  }

  // if (formData.orderBefore !== 0 && !formData.orderBefore) {
  //   errors.orderBefore = getTranslation('validation.orderBeforeRequired', language);
  //   console.error('Validation Error - orderBefore:', {
  //     error: errors.orderBefore,
  //     value: formData.orderBefore
  //   });
  // }

  // Use optional chaining for ingredients validation
  if (!formData.ingridientsDto?.[0]?.ingredientHy) {
    errors.ingredientHy = getTranslation('validation.ingredientRequired', language);
  }

  if (!formData.dishCuisineTagDto) {
    errors.dishCuisineTagDto = getTranslation('validation.cuisineTagRequired', language);
  }

  if (!formData.dishTagDto) {
    errors.dishTagDto = getTranslation('validation.dishTagDto', language);
  }

  if (formData.type !== "DESSERT" && !formData.spiceLevel) {
    errors.spiceLevel = getTranslation('validation.spiceLevelRequired', language);
  }

  if (!formData.url && !formData.image) {
    errors.url = getTranslation('validation.imageRequired', language);
  }

  // Fallback for missing translations
  Object.keys(errors).forEach(key => {
    if (!errors[key]) {
      // Provide a generic fallback if translation fails
      errors[key] = `Validation failed for ${key}`;
    }
  });

  return errors;
};

/**
 * Validates if a value is a valid price (digits only)
 * @param {string} value - The value to validate
 * @returns {boolean} True if the value is a valid price, false otherwise
 */
export const isValidPrice = (value) => {
  return value === "" || /^\d+$/.test(value);
};
